import {
  useEffect,
  useState,
} from "react";

import {
  createMatrixClient,
  startMatrixClient,
  destroyMatrixClient,
} from "../services/matrixClient";

import {
  MATRIX_DEV_USERS,
} from "../services/matrixDevConfig";

export default function useMatrix() {
  const [client, setClient] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState("");

  useEffect(() => {
    let active = true;

    async function connectToMatrix() {
      try {
        setLoading(true);
        setError("");

        const user =
          MATRIX_DEV_USERS.manager;

        const matrix =
          createMatrixClient(
            user.accessToken,
            user.userId
          );

        await startMatrixClient(matrix);

        if (!active) {
          return;
        }

        setClient(matrix);

      } catch (err) {
        console.error(
          "[CHAT] Matrix connection error:",
          err
        );

        if (active) {
          setError(
            err?.message ||
              "Не удалось подключиться к Matrix"
          );
        }

      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    connectToMatrix();

    return () => {
      active = false;
      destroyMatrixClient();
    };
  }, []);

  return {
    client,
    loading,
    error,
  };
}